import React from "react";
import { createPortal } from "react-dom";
import loader from "./loader.gif";

export default function CasinoLoader() {
  const loaderOverlay = (
    <div
      role="status"
      aria-label="Loading casino game"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2147483647,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        backgroundColor: "#000",
        pointerEvents: "all",
      }}
    >
      <img
        src={loader}
        alt="Loading casino game"
        style={{
          display: "block",
          width: "min(100%, 525px)",
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );

  return createPortal(loaderOverlay, document.body);
}
